import { render, staticRenderFns } from "./EducationDocumentPreview.vue?vue&type=template&id=5fd26d56&scoped=true"
import script from "./EducationDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./EducationDocumentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd26d56",
  null
  
)

export default component.exports